import React from 'react';
import classNames from 'classnames';

import {frontend, WidgetSelectionRect} from 'pageflow-scrolled/frontend';

import styles from './adLabeling.module.css';

frontend.widgetTypes.register('adLabeling', {
  component: function Footer({configuration, navigationExpanded}) {
    return (
      <div className={classNames(
        styles.wrapper,
        styles[`display-${configuration.displayMode || 'firstSection'}`],
        {[styles.expanded]: navigationExpanded
      })}>
        <WidgetSelectionRect>
          <div className={styles.label}>
            Anzeige
          </div>
        </WidgetSelectionRect>
      </div>
    );
  }
});
